import { render } from "./EditHouseholdModal.vue?vue&type=template&id=8cdf1ea2&scoped=true"
import script from "./EditHouseholdModal.vue?vue&type=script&lang=js"
export * from "./EditHouseholdModal.vue?vue&type=script&lang=js"

import "./EditHouseholdModal.vue?vue&type=style&index=0&id=8cdf1ea2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdf1ea2"]])

export default __exports__